import { render, staticRenderFns } from "./Snippet.vue?vue&type=template&id=588733b6&scoped=true&"
import script from "./Snippet.vue?vue&type=script&lang=js&"
export * from "./Snippet.vue?vue&type=script&lang=js&"
import style0 from "./Snippet.vue?vue&type=style&index=0&id=588733b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588733b6",
  null
  
)

export default component.exports